import { Link } from "react-router-dom";
import { ArrowLeft, CalendarBlank, Check } from "@phosphor-icons/react";

const CAL_LINK = process.env.REACT_APP_CAL_LINK || "https://cal.com/sweatwithslay/discovery";

export default function Book() {
  return (
    <main data-testid="book-page" className="bg-[#0A0A0A] text-white font-body min-h-screen">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 lg:py-20">
        <Link to="/" className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-white/50 hover:text-[#FF1B91] mb-10"><ArrowLeft size={14} weight="bold" /> Back to Sweat With Slay</Link>
        <div className="flex items-center gap-3 mb-6"><span className="h-px w-10 bg-[#FF1B91]" /><p className="text-[11px] uppercase tracking-[0.4em] text-[#FF1B91] font-semibold">Discovery Call</p></div>
        <h1 className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.9] tracking-tighter mb-6">Book a <span className="font-brush font-normal normal-case text-[#FF1B91] -rotate-2 inline-block">call</span></h1>
        <p className="text-white/75 leading-relaxed max-w-2xl mb-8 text-lg">Pick a time that works for you. Every request goes <strong className="text-white">pending until I confirm</strong> — usually within 24 hours.</p>
        <div className="flex flex-wrap gap-3 mb-10 text-xs uppercase tracking-[0.25em] text-white/55">
          <span className="border border-white/15 px-3 py-2 inline-flex items-center gap-2"><Check size={14} weight="bold" className="text-[#FF1B91]" /> 20 minutes</span>
          <span className="border border-white/15 px-3 py-2 inline-flex items-center gap-2"><Check size={14} weight="bold" className="text-[#FF1B91]" /> Free</span>
          <span className="border border-white/15 px-3 py-2 inline-flex items-center gap-2"><Check size={14} weight="bold" className="text-[#FF1B91]" /> Pending until I confirm</span>
        </div>
        <div className="border border-white/10 bg-[#0F0F0F] p-2 sm:p-4">
          <iframe
            data-testid="book-iframe"
            title="Book a discovery call with Slay"
            src={CAL_LINK}
            className="w-full border-0 bg-white"
            style={{ minHeight: "1100px" }}
            allow="payment"
          />
        </div>
        <p className="mt-6 text-[11px] uppercase tracking-[0.3em] text-white/40 text-center">Prefer the long form? <Link to="/intake" className="text-[#FF1B91] hover:underline">Take the intake instead →</Link></p>
        <div className="mt-4 text-center text-[11px] uppercase tracking-[0.25em] text-white/30">
          <a href={CAL_LINK} target="_blank" rel="noreferrer noopener" className="hover:text-[#FF1B91]" data-testid="book-direct">Open in new window <CalendarBlank size={12} weight="bold" className="inline" /></a>
        </div>
      </div>
    </main>
  );
}
